import { getForbiddenRedirectPath } from "utils/accessibleRoutes"

/**
 * Full-page redirect when an API returns 403 (permission denied).
 * Sends the user to their first allowed module, or /forbidden if none.
 */
export const redirectOnApiForbidden = () => {
  if (typeof window === "undefined") return

  const target = getForbiddenRedirectPath()
  const current = `${window.location.pathname}${window.location.search}`

  if (current === target || window.location.pathname === target) {
    return
  }

  window.location.replace(target)
}
